import { render } from "./datacalendar.vue?vue&type=template&id=51446dc1"
import script from "./datacalendar.vue?vue&type=script&lang=js"
export * from "./datacalendar.vue?vue&type=script&lang=js"

import "./datacalendar.vue?vue&type=style&index=0&id=51446dc1&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__